import Button from '@components/button'
import Column from '@components/column'
import Fields from '@components/fields'
import Grid from '@components/grid'
import Row from '@components/row'
import Title from '@components/title'
import Wrapper from '@components/wrapper'
import { Form, Formik } from 'formik'
import React, { Fragment } from 'react'
import { outlineButton } from '../payment/settings/form'
import PushNotificationForm from './form'
import NotificationList from './list'

const PushNotifications = () => {
  return (
    <Fragment>
      <Column>
        <Title textone="Push" texttwo="Notifications" />

        <PushNotificationForm />
        <NotificationList />
      </Column>
    </Fragment>
  )
}

export default PushNotifications
